// extracted by mini-css-extract-plugin
export default {"container":"ProcuraSe_container__jfXoS","titulo":"ProcuraSe_titulo__KaM0r"};